export default __webpack_public_path__ + "static/media/Broker-Consultant-Nelspruit-2026-002.714f4e5c.pdf";